import { modalIds } from '@const/modals';
import { apiPayBillService } from '@api';
import { routes } from '@const/routes';
import useModalContext from '@hooks/context/useModalContext';
import { useNavigate } from 'react-router-dom';
import { useLocales } from '@hooks/helpers/useLocales';

export const usePayBillsModal = () => {
    const { onOpen, onClose, handleChangeLoading, changeModalData } = useModalContext();
    const navigate = useNavigate();
    const { requestErrorLocale, requestSuccessLocale } = useLocales();

    const handleDeletePayeeModal = (id: string, name: string, refetchContacts: () => void) => {
        changeModalData({ name });
        onOpen({
            modalId: modalIds.DELETE_PAYEE,
            onSubmit: () => {
                handleChangeLoading(true);
                apiPayBillService
                    .deletePayee(id)
                    .then(() => {
                        requestSuccessLocale('delete_payee');
                        refetchContacts();
                        navigate(routes.pay_bills_payees);
                        onClose();
                    })
                    .catch(requestErrorLocale)
                    .finally(() => handleChangeLoading(false));
            }
        });
    };

    return { handleDeletePayeeModal };
};
